
<!--
 * @Description: 学生 详情 请假信息
 * @Author: PF
 * @Date: 2023-11-30 10:20:27
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 13:56:28
-->
<template>
  <div class="hp100" v-if="tableData.length">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="异动类型" prop="ydlb" align="center">
        <template #default="scope">
          <span v-for="(item, index) in xjydlxData.list" :key="index">
            <span v-if="scope.row.ydlb == item.value">{{item.label}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="异动日期" prop="ydrq" align="center" />
      <el-table-column label="原班级" prop="ybjmc" align="center" />
      <el-table-column label="现班级" prop="xbjmc" align="center" />
      <el-table-column label="状态" prop="zt" align="center">
        <template #default="scope">
          <span v-for="(item, index) in xjydztData.list" :key="index">
            <span v-if="scope.row.zt == item.value">{{item.label}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="120">
        <template #default="scope">
          <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
    <el-empty v-else class="hp100" description="暂无信息" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'
import { getXjydlx, getXjydxt } from '@/utils/meiju.js'
import detail from '@/pages/jiaowu/xuejiguanli/xuejiyidong/detail.vue'

const props = defineProps({
  row: { type: Object, required: false }
})

const tableData = ref([])

const xjydlxData = ref({list:[]})
const xjydztData = ref({list:[]})

watch(
  () => props.row,
  () => {
    if (props.row) {
      xjydlxData.value = getXjydlx()
      xjydztData.value = getXjydxt()
      loadSelect({ url: '/api/v2/jiaowu/xueshengxuejiyidongjilu/list', data: tableData, parms: { keyword: props.row.xh, order: 'ydrq', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
const row = ref({})
const openDetail = ref(false)
</script>
